import axiosInstance from './axiosConfig';

export type GenerationType = 'image' | 'video' | 'manga' | 'lp' | 'music' | 'document' | 'banner_ab_test';

export interface GenerationStatus {
  id: string;
  type: GenerationType;
  status: string;
  progress: number;
  step: string | null;
  error: string | null;
  is_generating: boolean;
  created_at: string | null;
  updated_at: string | null;
  /** banner_ab_test だけが返す。useGenerationPolling は data の中にそのまま入れるので polling.data?.round で読む */
  mode?: string;
  round?: number;
  max_rounds?: number;
  stopped_reason?: string | null;
}

class GenerationStatusService {
  async getStatus(type: GenerationType, id: string): Promise<GenerationStatus> {
    const response = await axiosInstance.get<{ success: boolean; data: GenerationStatus }>(
      `/generation/${type}/${id}/status`
    );
    return response.data.data;
  }

  async getActiveJobs(): Promise<GenerationStatus[]> {
    const response = await axiosInstance.get<{ success: boolean; data: GenerationStatus[] }>(
      '/generation/active'
    );
    return response.data.data;
  }

  async getTypes(): Promise<GenerationType[]> {
    const response = await axiosInstance.get<{ success: boolean; data: GenerationType[] }>(
      '/generation/types'
    );
    return response.data.data;
  }
}

export default new GenerationStatusService();
